import { FunctionComponent } from 'react'
import styled from 'styled-components'
import SvgFragment from '../../../../fragments/SvgFragment'
import TooltipWrapper from '../../../../components/TooltipWrapper'
import { styles } from '../../../../styles/themes/style'

import { getSyncContactsTooltip } from '../../../../utils/syncContactsTooltips'
import { isChromeBasedBrowser } from '../../../../utils'

interface IHomeHighlightsSyncPromptProps {
    title: string
    subtitle: string
    onSyncContacts: () => void
    extensionInstalled?: boolean
    loading?: boolean
}

const HomeHighlightsSyncPrompt: FunctionComponent<IHomeHighlightsSyncPromptProps> = ({
    title,
    subtitle,
    onSyncContacts,
    extensionInstalled = true,
    loading = false,
}) => {
    const isDisabled = loading || !isChromeBasedBrowser() || !extensionInstalled
    const syncTooltip = getSyncContactsTooltip(extensionInstalled)

    return (
        <Prompt>
            <LockIcon aria-hidden>
                <SvgFragment type="lock" />
            </LockIcon>
            <PromptTitle>{title}</PromptTitle>
            <PromptSubtitle>{subtitle}</PromptSubtitle>
            <TooltipWrapper tooltipText={syncTooltip}>
                <SyncButton
                    type="button"
                    disabled={isDisabled}
                    onClick={() => isChromeBasedBrowser() && extensionInstalled && onSyncContacts()}
                >
                    Sync Contacts
                </SyncButton>
            </TooltipWrapper>
        </Prompt>
    )
}

const Prompt = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 8px 0 0;
    text-align: center;
`

const LockIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;

    & .svg {
        width: 17px;
        height: 18px;
    }
`

const PromptTitle = styled.p`
    margin: 0;
    font-family: NunitoSans, 'Nunito Sans', sans-serif;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    color: ${styles.colors.black600};
`

const PromptSubtitle = styled.p`
    margin: 0;
    font-family: NunitoSans, 'Nunito Sans', sans-serif;
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    color: ${styles.colors.black400};
`

const SyncButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 4px;
    padding: 6px 12px;
    min-height: 32px;
    border-radius: 8px;
    border: 1px solid ${styles.colors.black200};
    background: ${styles.colors.white};
    color: ${styles.colors.black500};
    font-family: NunitoSans, 'Nunito Sans', sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover:not(:disabled) {
        background: ${styles.colors.black100};
    }

    &:disabled {
        opacity: 0.55;
        cursor: default;
    }
`

export default HomeHighlightsSyncPrompt
